import React from 'react';
import { useField } from 'formik';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';

export const NameField: React.FC = () => {
  const [field, meta] = useField<string>({ name: 'name' });

  return (
    <FormField
      label={<Label>Name</Label>}
      required
      control={<Input {...field} autoComplete={'off'} />}
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
